import { PropsWithChildren, useRef } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'

import { useMedia } from 'hooks/useMedia'
import { ParallaxOverflow, ParallaxContainer } from './styled'

export const Parallax = ({
  side,
  children,
}: PropsWithChildren<{ side: string }>) => {
  const ref = useRef(null)
  const isDesktop = useMedia([`(min-width: ${1025 / 16}em)`], [true], false)

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['end end', 'start start'],
  })

  const move = useTransform(scrollYProgress, [0, 1], ['30vh', '-30vh'])

  return (
    <ParallaxOverflow>
      <ParallaxContainer ref={ref} $side={side}>
        <motion.div style={{ translateY: isDesktop ? move : '0vh' }}>
          {children}
        </motion.div>
      </ParallaxContainer>
    </ParallaxOverflow>
  )
}
